import CreatePin from './CreatePin';

export default CreatePin;
